import React, { useEffect, useState, useMemo } from 'react';
import { Link } from "react-router-dom";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import DatePicker, { DateObject } from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import Select from "react-select";
import axios from 'axios';
import arrow from "../../../../images/arrow.png";
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';    
import moment from 'moment';
import OrderBill from '../Manage_customer/Order_Bill';
import ReactDOMServer from 'react-dom/server';
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const CateringOrder = () => {
    const BaseUrl = process.env.REACT_APP_API_BASE_URL;
    const [selectedOption, setSelectedOption] = useState(null);
    const [service_sttm, setServiceSTTMValue] = useState(new DateObject({ hour: 6, minute: 0, meridiem: 'AM' }));
    const [wastageType, setWastageType] = useState("food");
    const [showAddOnSection, setShowAddOnSection] = useState(false);
    const [checkedItems, setCheckedItems] = useState({});
    // const [cateringType, setCateringType] = useState({});
    const [cateringType, setCateringType] = useState([]);

    const [functionType, setFunctionType] = useState({});
    const [addOnService, setAddOnService] = useState({});
    const [mealsPeriod, setMealsPeriod] = useState([]);
    const [customer, setCustomer] = useState({});
    const [categorizedItems, setCategorizedItems] = useState([]);
    const [items, setItems] = useState({});
    const [selectedService, setSelectedService] = useState(null);
    const [selectedVendor, setSelectedVendor] = useState(null);
    const [quantity, setQuantity] = useState('');
    const [totalCost, setTotalCost] = useState(0);
    const [vendors, setVendors] = useState();
    const [grandTotal, setGrandTotal] = useState(0);
    const [gst_percentage, setGstPercentage] = useState(0);
    const [refundEligible, setRefundEligible] = useState(0);
    const [confirmCost, setConfirmCost] = useState('');
    const [gstAmount, setGstAmount] = useState(0);
    const [totalWithGst, setTotalWithGst] = useState(0);
    const [itemQuantities, setItemQuantities] = useState({});
    const [coupon, setCoupon] = useState('');
    const [couponId, setCouponId] = useState(null);
    const [couponAmount, setCouponAmount] = useState(0);
    const navigate = useNavigate();
    // const [selectedCateringType, setSelectedCateringType] = useState(null);
    // const [cateringType, setCateringType] = useState([]);
    const [selectedCateringType, setSelectedCateringType] = useState(null);
    const [selectedOrderDate, setSelectedOrderDate] = useState(null);
    const [selectedMealsPeriod, setSelectedMealsPeriod] = useState(null);
    const [selectedFunctionType, setSelectedFunctionType] = useState(null);
    const [deliveryAddress, setDeliveryAddress] = useState('');
    const [headCount, setHeadCount] = useState('');
    const [specialRequest, setSpecialRequest] = useState('');
    const [paymentClosingDate, setPaymentClosingDate] = useState(null);
    const [advanceAmount, setAdvanceAmount] = useState('');
    const [errors, setErrors] = useState({});
    const [units, setUnits] = useState([]);
    const [advanceAmountInput, setAdvanceAmountInput] = useState('');
    const [advancePercentage, setAdvancePercentage] = useState(0);

    useEffect(() => {
        console.log(checkedItems);
    }, [checkedItems]);

    const handleQuantityChangeForItem = (itemId, quantity) => {
        setItemQuantities(prev => ({
            ...prev,
            [itemId]: quantity,
        }));
    };

    const checkedItemsTotal = categorizedItems.reduce((sum, group) => {
        return (
            sum +
            group.items.reduce((groupSum, item) => {
                if (checkedItems[item.id]) {
                    const quantity = itemQuantities[item.id] || 0;
                    const cost = parseFloat(item.cost) || 0;
                    return groupSum + cost * quantity;
                }
                return groupSum;
            }, 0)
        );
    }, 0);

    const handleServiceChange = (selectedOption, index) => {
        setRawMatrial(prev =>
            prev.map((item, i) =>
                i === index
                    ? {
                        ...item,
                        selectedService: selectedOption,
                        costPerUnit: selectedOption?.cost_per_unit || 0,
                        totalCost: (selectedOption?.cost_per_unit || 0) * item.quantity
                    }
                    : item
            )
        );
    };

    const handleQuantityChange = (e, index) => {
        const quantity = parseFloat(e.target.value || 0);
        setRawMatrial(prev =>
            prev.map((item, i) =>
                i === index
                    ? {
                        ...item,
                        quantity,
                        totalCost: quantity * (item.costPerUnit || 0)
                    }
                    : item
            )
        );
    };

    const handleVendorChange = (selectedVendor, index) => {
        setRawMatrial(prev =>
            prev.map((item, i) =>
                i === index
                    ? { ...item, selectedVendor }
                    : item
            )
        );
    };

    // const fetchCateringType = async () => {
    //     try {
    //         const response = await axios.get(`${BaseUrl}/cateringtype/getactive`);
    //         if (response.data && Array.isArray(response.data)) {
    //             const formatted = response.data.map(item => ({
    //                 value: String(item.sno),
    //                 label: item.catering_type
    //             }));
    //             setCateringType(formatted);
    //         }
    //     } catch (error) {
    //         console.error('Failed to fetch Catering Type:', error);
    //         setCateringType([]);
    //     }
    // };


const fetchCateringType = async () => {
  try {
    const response = await axios.get(`${BaseUrl}/cateringtype/getactive`);

    const apiData = response.data;  // <-- your API sends a plain array

    if (Array.isArray(apiData)) {
      setCateringType(
        apiData.map(item => ({
          value: String(item.sno),
          label: item.catering_type
        }))
      );
    } else {
      setCateringType([]);
    }
  } catch (error) {
    console.error("Failed to fetch Catering Type:", error);
    setCateringType([]);
  }
};

    const fetchFunctionType = async () => {
        try {
            const response = await axios.get(`${BaseUrl}/functiontype/getactive`);
            if (response.data && Array.isArray(response.data)) {
                const formatted = response.data.map(item => ({
                    value: String(item.sno),
                    label: item.function_type
                }));
                setFunctionType(formatted);
            }
        } catch (error) {
            console.error('Failed to Function Type:', error);
            setFunctionType({});
        }
    };

    const fetchUnits = async () => {
        try {
            const response = await axios.get(`${BaseUrl}/manageunit/list/active`);
            if (response.data && response.data.data) {
                setUnits(response.data.data);  // <-- this is the array you want
            } else {
                setUnits([]);
            }
        } catch (error) {
            console.error('Failed to Function Type:', error);
            setUnits([]);
        }
    };

    const getUnitSlugName = (unitId) => {
        if (!unitId) return '';
        const idNum = Number(unitId);
        if (isNaN(idNum)) return '';
        const matchedUnit = units.find(unit => Number(unit.sno) === idNum);
        return matchedUnit ? matchedUnit.unitslug_name : '';
    };

    const fetchitemSchedule = async () => {
        try {
            const response = await axios.get(`${BaseUrl}/item-schedule/items/active`);

            const list = response.data?.data;

            if (Array.isArray(list)) {
                const formatted = list.map(item => ({
                    value: String(item.sno),
                    label: item.itemschedule_name
                }));
                setMealsPeriod(formatted);
            } else {
                setMealsPeriod([]); // fallback to empty array
            }
        } catch (error) {
            console.error('Failed to fetch Meals period:', error);
            setMealsPeriod([]); // fallback to empty array, not object
        }
    };

    const fetchAddOnService = async () => {
        try {
            const response = await axios.get(`${BaseUrl}/addonservice/getactive`);
            if (response.data && Array.isArray(response.data)) {
                const formatted = response.data.map(item => ({
                    value: String(item.sno),
                    label: item.service,
                    vendor: item.vendor,
                    cost_per_unit: item.cost_per_unit,
                }));
                setAddOnService(formatted);
            }
        } catch (error) {
            console.error('Failed to Add On Service Type:', error);
            setAddOnService({});
        }
    };

    const fetchCustomer = async (cust_id) => {
        try {
            const response = await axios.get(`${BaseUrl}/manage_customer/get/${cust_id}`);

            if (response.data) {
                setCustomer(response.data);
                // console.log(response.data);
            } else {
                console.error('No customer data found for this ID');
                setCustomer(null); // or however you want to handle no data
            }
        } catch (error) {
            console.error('Error fetching customer data:', error);
            setCustomer(null); // clear or reset state on error
        }
    };

    const [searchTerm, setSearchTerm] = useState("");

    const fetchItems = async (scheduleID) => {
        try {
            const response = await axios.get(`${BaseUrl}/manage_order/get_items_by_schedule/${scheduleID}`);
            if (response.data?.data) {
                setItems(response.data.data);
                setCategorizedItems(response.data.data); // <-- Proper state update
                // console.log('Fetched categorized items:', response.data.data);
            } else {
                console.error('No items found for this schedule ID');
                setItems(null);
                setCategorizedItems([]);
            }
        } catch (error) {
            console.error('Error fetching items:', error);
            setItems(null);
            setCategorizedItems([]);
        }
    };

    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);

    const fetchVendors = async (branch_id) => {
        try {
            const response = await axios.get(`${BaseUrl}/manage_order/get_vendors/${branch_id}`);

            if (response.data?.data) {
                // Map the data to the required format
                const formattedVendors = response.data.data.map(vendor => ({
                    value: vendor.sno.toString(),             // or vendor.vendor_id if you want unique string id
                    label: vendor.vendor_businessname || 'Unknown Vendor',
                }));

                setVendors(formattedVendors);

                // Optional: console.log to check format
                // console.log('Formatted Vendors:', formattedVendors);
            } else {
                console.error('No vendors found for this branch ID');
                toast.error('Not Able to Fetch Vendors');
                setVendors([]);
            }
        } catch (error) {
            console.error('Error fetching vendors:', error);
            setVendors([]);
        }
    };

    const getGST = () => {
        axios.get(`${BaseUrl}/generalSetting/1`)
            .then(response => {
                if (response.data && response.data.data) {
                    setGstPercentage(parseFloat(response.data.data.gst));
                    setRefundEligible(parseFloat(response.data.data.max_refund_eligible));
                    setAdvancePercentage(parseFloat(response.data.data.refund_deducted));

                } else {
                    // console.log("Unexpected API response structure:", response);
                    setGstPercentage(5);
                }
            })
            .catch(error => {
                // console.log("Failed to fetch general settings:", error);
                setGstPercentage(5);
            });
    }

    useEffect(() => {
        const customerId = localStorage.getItem('selectedCustomerId');
        fetchCustomer(customerId);
        fetchAddOnService();
        fetchFunctionType();
        fetchCateringType();
        fetchitemSchedule();
        fetchUnits();
        fetchVendors(branch_id);
        getGST();
        setLoading(false);
    }, []);

    const handleAddOnToggle = (e) => {
        setShowAddOnSection(e.target.checked);
    };

    const handleItemCheckboxChange = (itemId, isChecked) => {
        setCheckedItems(prev => ({
            ...prev,
            [itemId]: isChecked,
        }));

        if (isChecked && headCount > 0) {
            const item = categorizedItems
                .flatMap(group => group.items)
                .find(i => i.id === itemId);

            if (item && item.per_person) {
                const qty = parseFloat(headCount) * parseFloat(item.per_person);
                setItemQuantities(prev => ({
                    ...prev,
                    [itemId]: Number(qty.toFixed(2)),
                }));
            }
        }
    };

    const [rawMatrial, setRawMatrial] = useState([{ id: Date.now() }]);

    const handleAddConfig = () => {
        setRawMatrial([...rawMatrial, { id: Date.now() }]);
    };

    const handleDeleteConfig = (id) => {
        setRawMatrial(rawMatrial.filter(config => config.id !== id));
    };

    const handleConfirmCostChange = (e) => {
        const value = e.target.value;
        if (/^\d*\.?\d*$/.test(value)) {
            setConfirmCost(value);
            const costNumber = parseFloat(value) || 0;
            const gst = (costNumber * gst_percentage) / 100;
            setGstAmount(gst);
            setTotalWithGst(costNumber + gst);
            const autoAdvance = (costNumber * advancePercentage) / 100;
            setAdvanceAmount(autoAdvance);
            setAdvanceAmountInput(autoAdvance);
        }
    };


    useEffect(() => {
        const rawMaterialTotal = showAddOnSection
            ? rawMatrial.reduce((sum, item) => sum + (item.totalCost || 0), 0)
            : 0;

        const checkedItemsTotal = categorizedItems.reduce((sum, group) => {
            return (
                sum +
                group.items.reduce((groupSum, item) => {
                    if (checkedItems[item.id]) {
                        const quantity = itemQuantities[item.id] || 0;
                        const cost = parseFloat(item.cost) || 0;
                        return groupSum + cost * quantity;
                    }
                    return groupSum;
                }, 0)
            );
        }, 0);

        setGrandTotal(rawMaterialTotal + checkedItemsTotal);
    }, [rawMatrial, checkedItems, itemQuantities, categorizedItems, showAddOnSection]);


    const selectedItems = categorizedItems.flatMap(group =>
        group.items
            .filter(item => checkedItems[item.id])
            .map(item => {
                const quantity = itemQuantities[item.id] || 0;
                // console.log(`Item ID: ${item.id}, Quantity: ${quantity}`);
                return {
                    id: item.id,
                    name: item.name,
                    quantity: quantity > 0 ? quantity : 1,
                    category: group.category,
                    sub_category: group.sub_category,
                    cost: item.cost || 0,
                    measurement_quantity: item.measurement_quantity,
                    measurement_unit: item.catering_corp_unit,
                };
            })
    );


    const handleApplyClick = () => {
        if (!coupon) {
            toast.error('Coupon Code is Required.');
            return;
        }

        const filter = {
            coupon_code: coupon,
            coupon_for: 1,
        };

        axios.get(`${BaseUrl}/coupon/code`, { params: filter })
            .then(response => {
                const data = response.data.data;
                if (data) {
                    setCouponId(data.sno);

                    let discountValue = 0;
                    if (data.coupon_type === 0) {
                        // fixed amount discount
                        discountValue = parseFloat(data.coupon_value);
                    } else if (data.coupon_type === 1) {
                        // percentage discount
                        const percentage = parseFloat(data.coupon_value);
                        discountValue = confirmCost * (percentage / 100);
                    }

                    setCouponAmount(discountValue);

                    // Calculate new amount after discount
                    const discountedAmount = confirmCost - discountValue;

                    // Calculate GST on discounted amount
                    const newGstAmount = discountedAmount * (gst_percentage / 100);

                    setGstAmount(newGstAmount);

                    // Calculate new total including GST
                    const newTotal = discountedAmount + newGstAmount;

                    setTotalWithGst(newTotal);
                } else {
                    setCouponAmount(0);
                    toast.error('Coupon not valid or expired');
                    setCouponId(null);
                }
            })
            .catch(error => {
                setCouponAmount(0);
                console.error('There was an error fetching the data!', error);
                toast.error('Error fetching coupon. Please try again.');
                setCouponId(null);
            });
    };

    const validateForm = () => {
        const newErrors = {};
        const today = new Date();
        today.setHours(0, 0, 0, 0); // reset to midnight for date comparison

        // Catering Type required
        if (!selectedCateringType) {
            newErrors.selectedCateringType = "Catering Type is required";
        }

        // Order Date required & can't be before today
        if (!selectedOrderDate) {
            newErrors.selectedOrderDate = "Order Date is required";
        } else {
            const orderDate = new Date(selectedOrderDate);
            orderDate.setHours(0, 0, 0, 0);
            if (orderDate < today) {
                newErrors.selectedOrderDate = "Order Date cannot be before today";
            }
        }

        // Order Time required
        if (!service_sttm) {
            newErrors.service_sttm = "Order Time is required";
        }

        // Meals Period required
        if (!selectedMealsPeriod) {
            newErrors.selectedMealsPeriod = "Meals Period is required";
        }

        // Function Type required
        if (!selectedFunctionType) {
            newErrors.selectedFunctionType = "Function Type is required";
        }

        // Delivery Address required and non-empty
        if (!deliveryAddress || !deliveryAddress.trim()) {
            newErrors.deliveryAddress = "Delivery Address is required";
        }

        // Head Count must be a number > 0
        if (!headCount || isNaN(headCount) || Number(headCount) <= 0) {
            newErrors.headCount = "Please enter a valid Head Count (number > 0)";
        }

        // Payment Closing Date required and must be today or after
        if (!paymentClosingDate) {
            newErrors.paymentClosingDate = "Payment Closing Date is required";
        } else {
            const paymentDate = new Date(paymentClosingDate);
            paymentDate.setHours(0, 0, 0, 0);
            if (paymentDate < today) {
                newErrors.paymentClosingDate = "Payment Closing Date cannot be before today";
            }
        }

        // Validate checked items quantity > 0
        Object.entries(checkedItems).forEach(([itemId, isChecked]) => {
            if (isChecked) {
                const qty = itemQuantities[itemId];
                if (!qty || isNaN(qty) || Number(qty) <= 0) {
                    newErrors[`itemQuantity_${itemId}`] = "Please enter valid quantity (>0)";
                }
            }
        });


        // Validate add-on services if visible
        if (showAddOnSection) {
            rawMatrial.forEach((config, idx) => {
                if (!config.selectedService) {
                    newErrors[`addOnService_${idx}`] = "Service is required";
                }
                if (config.selectedService && config.selectedService.vendor === 0 && !config.selectedVendor) {
                    newErrors[`addOnVendor_${idx}`] = "Vendor is required";
                }
                if (!config.quantity || isNaN(config.quantity) || Number(config.quantity) <= 0) {
                    newErrors[`addOnQuantity_${idx}`] = "Enter valid units (>0)";
                }
                if (
                    config.totalCost === undefined ||
                    config.totalCost === null ||
                    isNaN(config.totalCost) ||
                    Number(config.totalCost) < 0
                ) {
                    newErrors[`addOnCost_${idx}`] = "Enter valid total cost (>= 0)";
                }
            });
        }

        const parsedConfirmCost = parseFloat(confirmCost);

        if (isNaN(parsedConfirmCost) || parsedConfirmCost < 0) {
            newErrors.confirmCost = "Confirm Cost must be more than Zero";
        }

        const parsedAdvanceAmount = parseFloat(advanceAmountInput);


        if (
            advanceAmountInput == '' ||
            isNaN(parsedAdvanceAmount)
        ) {
            newErrors.advanceAmount = "Advance Amount is required";
        } else if (parsedAdvanceAmount < advanceAmount) {
            newErrors.advanceAmount = `Advance Amount must be ₹${advanceAmount} or more`;
        }


        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async () => {
        setErrors(null);

        if (!validateForm()) {
            return;
        }

        const addOnServices = showAddOnSection
            ? rawMatrial
                .filter(config => config.selectedService)
                .map(config => ({
                    service: config.selectedService.value,
                    vendor: config.selectedVendor ? config.selectedVendor.value : null,
                    quantity: config.quantity,
                    totalCost: config.totalCost,
                }))
            : [];

        const dataToSend = {
            cateringType: selectedCateringType.value,
            orderDate: new Date(selectedOrderDate).toLocaleDateString('en-CA'),
            orderTime: new Date(service_sttm).toTimeString().slice(0, 5),
            mealsPeriod: selectedMealsPeriod.value,
            functionType: selectedFunctionType.value,
            deliveryAddress: deliveryAddress.trim(),
            headCount: Number(headCount),
            specialRequest: specialRequest.trim(),
            paymentClosingDate: new Date(paymentClosingDate).toLocaleDateString('en-CA'),
            addOnService: addOnServices,
            items: selectedItems,
            advanceAmount: Number(advanceAmountInput),
            confirmCost: Number(confirmCost),
            coupon: coupon,
            branch_id: branch_id,
            customer_id: customer.sno,
            total: totalWithGst,
            gst: gstAmount,
            couponamount: couponAmount,
        };

        // console.log("Prepared data to send:", JSON.stringify(dataToSend, null, 2));

        try {

            const user_id = parseInt(localStorage.getItem("user_id"), 10);
            const response = await fetch(`${BaseUrl}/manage_order/create_order/${user_id}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(dataToSend),
            });

            if (!response.ok) {
                const errorData = await response.json();
                toast.error('Failed to create order');
            }

            const result = await response.json();
            toast.success('Order created successfully!');
            navigate('/manage-catering-customer');
        } catch (error) {
            setErrors(error.message);
        }
    };

    const selectedItemsForPrint = selectedItems.map(item => ({
        name: item.name,
        quantity: `${item.quantity} ${getUnitSlugName(item.measurement_quantity)}`,
        pricePerQty: parseFloat(item.cost).toFixed(2),
        total: (item.quantity * item.cost).toFixed(2),
    }));

    const addOnServicesForPrint = rawMatrial
        .filter(item => item.selectedService && item.quantity > 0)
        .map(item => {
            const costPerUnit = parseFloat(item.selectedService?.cost_per_unit) || 0;
            const totalCost = parseFloat(item.totalCost) || costPerUnit * item.quantity;

            // console.log('costPerUnit:', costPerUnit, 'totalCost:', totalCost);

            return {
                name: item.selectedService.label,
                quantity: item.quantity,
                costPerUnit: costPerUnit.toFixed(2),
                total: totalCost.toFixed(2),
            };
        });

    const order = {
        orderDate: selectedOrderDate ? moment(selectedOrderDate).format("DD-MM-YYYY") : "",
        orderNumber: customer.customer_name,
        totalCost: grandTotal.toFixed(2),
        confirmCost: parseFloat(confirmCost || 0).toFixed(2),
        advanceAmount: parseFloat(advanceAmount || 0).toFixed(2),
        couponAmount: parseFloat(couponAmount || 0).toFixed(2),
        gstAmount: gstAmount.toFixed(2),
        grandTotal: (parseFloat(confirmCost || 0) + gstAmount).toFixed(2),
        gst_percentage: gst_percentage,
    };

    const handlePrint = () => {
        const orderData = {
            orderDate: order?.orderDate,
            orderNumber: order?.orderNumber,
            selectedItems: selectedItemsForPrint || [],
            addOnServices: addOnServicesForPrint || [],
            totalCost: order?.totalCost || 0,
            confirmCost: order?.confirmCost || 0,
            advanceAmount: order?.advanceAmount || 0,
            couponAmount: order?.couponAmount || 0,
            gstAmount: order?.gstAmount || 0,
            grandTotal: totalWithGst || 0,
            gst_percentage: gst_percentage,
        };

        // console.log('Sending orderData:', orderData);

        fetch(`${BaseUrl}/manage_order/preview_pdf`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(orderData),
        })
            .then(response => {
                if (response.headers.get('Content-Type') === 'application/pdf') {
                    return response.blob();
                }
                throw new Error('PDF generation failed.');
            })
            .then(blob => {
                const url = URL.createObjectURL(blob);
                window.open(url, '_blank');
            })
            .catch(error => {
                console.error('Error:', error);
                alert('Failed to generate PDF. Please try again.');
            });
    };

    const updateQuantitiesBasedOnHeadCount = (newHeadCount) => {
        if (!newHeadCount || newHeadCount <= 0) return;

        setItemQuantities(prevQuantities => {
            const newQuantities = { ...prevQuantities };

            categorizedItems.forEach(group => {
                group.items.forEach(item => {
                    if (checkedItems[item.id]) {
                        // quantity = headCount * catering_corp_quantity from DB
                        const quantity = newHeadCount * parseFloat(item.catering_corp_quantity || 0);
                        newQuantities[item.id] = Number(quantity.toFixed(2)); // round to 2 decimals
                    }
                });
            });

            return newQuantities;
        });
    };

    const handleHeadCountChange = (e) => {
        const val = e.target.value;
        if (/^\d*$/.test(val)) {
            const numericVal = parseInt(val, 10) || 0;
            setHeadCount(val);
            updateQuantitiesBasedOnHeadCount(numericVal);
        }
    };

    const filteredCategories = useMemo(() => {
        if (!searchTerm.trim()) return categorizedItems;

        const lowerSearch = searchTerm.toLowerCase();

        return categorizedItems
            .map(group => {
                const filteredItems = group.items.filter(item =>
                    item.name.toLowerCase().includes(lowerSearch)
                );
                return filteredItems.length > 0
                    ? { ...group, items: filteredItems }
                    : null;
            })
            .filter(Boolean);
    }, [searchTerm, categorizedItems]);
const [loading, setLoading] = useState(true);
    return (
        <>
          

<div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0">
<div className="mb-0">
  <div className="mb-0 px-0">
    {loading ? (
      <Skeleton width={200} height={24} />
    ) : (
      <h4 className="breadcrumb-header">Catering Order</h4>
    )}
  </div>

  <ol className="breadcrumb fs-7 d-flex gap-2">
    {loading ? (
      <>
        <li className="d-flex align-items-center">
          <Skeleton width={80} height={16} />
        </li>
        <li className="d-flex align-items-center">
          <Skeleton width={10} height={16} />
        </li>
        <li className="d-flex align-items-center">
          <Skeleton width={120} height={16} />
        </li>
        <li className="d-flex align-items-center">
          <Skeleton width={10} height={16} />
        </li>
        <li className="d-flex align-items-center">
          <Skeleton width={140} height={16} />
        </li>
      </>
    ) : (
      <>
        <li className="breadcrumb-item"><Link to="/dashboard">Dashboard</Link></li>
        <li className="breadcrumb-item"><i className="fa-solid fa-angles-right fs-8"></i></li>
        <li className="breadcrumb-item">Catering Management</li>
        <li className="breadcrumb-item"><i className="fa-solid fa-angles-right fs-8"></i></li>
        <li className="breadcrumb-item active">Manage Customer</li>
      </>
    )}
  </ol>
</div>


  {/* Right Section: Customer Info */}
  <div className="d-flex align-items-center justify-content-center gap-3 bg-gray-300 py-2 px-2 rounded">
    {loading ? (
      <div className="d-flex flex-column gap-1">
        <Skeleton width={150} height={20} />
        <Skeleton width={120} height={16} />
      </div>
    ) : (
      <div className="d-flex flex-column">
        <OverlayTrigger
          trigger={['hover', 'focus']}
          placement="bottom"
          overlay={<Tooltip><span>Customer Name</span></Tooltip>}
        >
          <label style={{ width: '150px' }}>{customer.customer_name}</label>
        </OverlayTrigger>
        <OverlayTrigger
          trigger={['hover', 'focus']}
          placement="bottom"
          overlay={<Tooltip><span>Customer Mobile</span></Tooltip>}
        >
          <label>{customer.customer_number}</label>
        </OverlayTrigger>
      </div>
    )}
  </div>
</div>


 

<div className="row mb-1 px-3">
  <h4 className="font-w600 text-black fs-4">
    {!customer ? <Skeleton width={200} height={28} /> : "Order Details"}
  </h4>

  {/* Catering Type */}
  <div className="col-lg-3 mb-4">
    {!customer ? (
      <>
        <Skeleton width={120} height={20} className="mb-2" />
        <Skeleton width="100%" height={40} />
      </>
    ) : (
      <>
        <label className="text-black font-w500 fs-6">
          Catering Type<span className="required">*</span>
        </label>
        {/* <Select
          placeholder="Select Catering Type"
          onChange={setSelectedCateringType}
        //   options={cateringType}
            options={cateringType || []}
        /> */}

        <Select
            placeholder="Select Catering Type"
            options={cateringType}
            onChange={setSelectedCateringType}
            />

        {errors.selectedCateringType && (
          <small className="text-danger">{errors.selectedCateringType}</small>
        )}
      </>
    )}
  </div>

  {/* Order Delivery Date */}
  <div className="col-lg-3 mb-4">
    {!customer ? (
      <>
        <Skeleton width={150} height={20} className="mb-2" />
        <Skeleton width="100%" height={40} />
      </>
    ) : (
      <>
        <label className="text-black font-w500 fs-6">
          Order Delivery Date<span className="required">*</span>
        </label>
        <div className="datepicker-wrapper d-flex">
          <div className="input-group-text bg-transparent border-0 px-0">
            <i className="fa-solid fa-calendar-days fs-4"></i>
          </div>
          <DatePicker
            placeholder="Select Date"
            value={selectedOrderDate}
            onChange={setSelectedOrderDate}
            format="DD-MM-YYYY"
            minDate={moment().add(3, "days").toDate()}
          />
        </div>
        {errors.selectedOrderDate && (
          <small className="text-danger">{errors.selectedOrderDate}</small>
        )}
      </>
    )}
  </div>

  {/* Order Delivery Time */}
  <div className="col-lg-3 mb-4">
    {!customer ? (
      <>
        <Skeleton width={150} height={20} className="mb-2" />
        <Skeleton width="100%" height={40} />
      </>
    ) : (
      <>
        <label className="text-black font-w500 fs-6">
          Order Delivery Time<span className="required">*</span>
        </label>
        <div className="datepicker-wrapper d-flex border-bottom border-gray-300">
          <div className="input-group-text bg-transparent border-0 px-0">
            <i className="fa-solid fa-clock fs-4"></i>
          </div>
          <DatePicker
            placeholder="Select Time"
            disableDayPicker
            value={service_sttm}
            onChange={setServiceSTTMValue}
            format="HH:mm"
            plugins={[<TimePicker hideSeconds />]}
          />
        </div>
        {errors.service_sttm && (
          <small className="text-danger">{errors.service_sttm}</small>
        )}
      </>
    )}
  </div>

  {/* Meals Period */}
  <div className="col-lg-3 mb-4">
    {!customer ? (
      <>
        <Skeleton width={120} height={20} className="mb-2" />
        <Skeleton width="100%" height={40} />
      </>
    ) : (
      <>
        <label className="text-black font-w500 fs-6">
          Meals Period<span className="required">*</span>
        </label>
        <Select
          placeholder="Select Meals Period"
          onChange={(selectedOption) => {
            setSelectedMealsPeriod(selectedOption);
            fetchItems(selectedOption.value);
          }}
          options={mealsPeriod}
          value={selectedMealsPeriod}
        />
        {errors.selectedMealsPeriod && (
          <small className="text-danger">{errors.selectedMealsPeriod}</small>
        )}
      </>
    )}
  </div>

  {/* Function Type */}
  <div className="col-lg-3 mb-4">
    {!customer ? (
      <>
        <Skeleton width={120} height={20} className="mb-2" />
        <Skeleton width="100%" height={40} />
      </>
    ) : (
      <>
        <label className="text-black font-w500 fs-6">
          Function Type<span className="required">*</span>
        </label>
        <Select
          placeholder="Select Function Type"
          onChange={setSelectedFunctionType}
          options={functionType}
          value={selectedFunctionType}
        />
        {errors.selectedFunctionType && (
          <small className="text-danger">{errors.selectedFunctionType}</small>
        )}
      </>
    )}
  </div>

  {/* Delivery Address */}
  <div className="col-lg-3 mb-2">
    {!customer ? (
      <>
        <Skeleton width={150} height={20} className="mb-2" />
        <Skeleton width="100%" height={60} />
      </>
    ) : (
      <>
        <label className="text-black font-w500 fs-6">
          Delivery Address<span className="required">*</span>
        </label>
        <textarea
          className="form-control"
          placeholder="Enter Delivery Address"
          value={deliveryAddress}
          onChange={(e) => setDeliveryAddress(e.target.value)}
        />
        {errors.deliveryAddress && (
          <small className="text-danger">{errors.deliveryAddress}</small>
        )}
      </>
    )}
  </div>

  {/* Head Count */}
  <div className="col-lg-3 mb-2">
    {!customer ? (
      <>
        <Skeleton width={150} height={20} className="mb-2" />
        <Skeleton width="100%" height={40} />
      </>
    ) : (
      <>
        <label className="text-black font-w500 fs-6">
          Head Count (in No's)<span className="required">*</span>
        </label>
        <input
          type="text"
          inputMode="numeric"
          pattern="[0-9]*"
          className="form-control"
          placeholder="Enter Head Count"
          value={headCount}
          onChange={handleHeadCountChange}
        />
        {errors.headCount && (
          <small className="text-danger">{errors.headCount}</small>
        )}
      </>
    )}
  </div>

  {/* Special Request */}
  <div className="col-lg-3 mb-2">
    {!customer ? (
      <>
        <Skeleton width={150} height={20} className="mb-2" />
        <Skeleton width="100%" height={60} />
      </>
    ) : (
      <>
        <label className="text-black font-w500 fs-6">
          Special Request (if Any)
        </label>
        <textarea
          className="form-control"
          value={specialRequest}
          onChange={(e) => setSpecialRequest(e.target.value)}
          placeholder="Enter Special Request"
        />
      </>
    )}
  </div>

  {/* Payment Closing Date */}
  <div className="col-lg-3 mb-2">
    {!customer ? (
      <>
        <Skeleton width={150} height={20} className="mb-2" />
        <Skeleton width="100%" height={40} />
      </>
    ) : (
      <>
        <label className="text-black font-w500 fs-6">
          Payment Closing Date<span className="required">*</span>
        </label>
        <div className="datepicker-wrapper d-flex">
          <div className="input-group-text bg-transparent border-0 px-0">
            <i className="fa-solid fa-calendar-days fs-4"></i>
          </div>
          <DatePicker
            placeholder="Select Date"
            value={paymentClosingDate}
            onChange={setPaymentClosingDate}
            format="DD-MM-YYYY"
          />
        </div>
        {errors.paymentClosingDate && (
          <small className="text-danger">{errors.paymentClosingDate}</small>
        )}
      </>
    )}
  </div>

  <hr />
</div>



            {selectedMealsPeriod && (
                <>
                    <div className="px-3">

                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h4 className='font-w600 text-black m-0 fs-4'>List Of Items</h4>

                            <input
                                type="text"
                                className="form-control"
                                placeholder="Search items..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                style={{ width: "250px" }}   // adjust as needed
                            />
                        </div>

                        {/* Scrollable Container */}
                        <div
                            className="border rounded p-3"
                            style={{
                                maxHeight: "500px",
                                overflowY: "auto",
                                overflowX: "hidden"
                            }}
                        >
                            {filteredCategories.length === 0 && (
                                <p className="text-muted">No items found.</p>
                            )}

                            {filteredCategories.map((group, index) => (
                                <div className="" key={index}>
                                    <label className="fs-6 text-primary mb-0 mt-2 font-w600">
                                        {group.category}
                                    </label>
                                    <label className="fs-8 text-primary mb-0 mt-2 font-w600">
                                        ({group.sub_category})
                                    </label>

                                    <div className="row mt-2">
                                        {group.items.map((item) => (
                                            <div className="col-lg-3 mb-3" key={item.id}>
                                                <div className='form-check'>
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        checked={checkedItems[item.id] || false}
                                                        onChange={(e) =>
                                                            handleItemCheckboxChange(item.id, e.target.checked)
                                                        }
                                                        id={`item-${item.id}`}
                                                    />
                                                    <label
                                                        className="form-check-label fs-7 text-black mb-0 font-w500"
                                                        htmlFor={`item-${item.id}`}
                                                    >
                                                        {item.name}
                                                        <span className="fs-9">
                                                            ({getUnitSlugName(item.measurement_quantity)})
                                                        </span>
                                                    </label>
                                                </div>

                                                {/* Quantity Box */}
                                                {checkedItems[item.id] && (
                                                    <input
                                                        type="text"
                                                        inputMode='numeric'
                                                        pattern="[0-9]*"
                                                        className="form-control mt-2"
                                                        placeholder={`Enter Count for ${item.name}`}
                                                        value={itemQuantities[item.id] || ""}
                                                        onChange={(e) =>
                                                            setItemQuantities((prev) => ({
                                                                ...prev,
                                                                [item.id]: e.target.value
                                                            }))
                                                        }
                                                    />
                                                )}

                                                {errors[`itemQuantity_${item.id}`] && (
                                                    <small className="text-danger">
                                                        {errors[`itemQuantity_${item.id}`]}
                                                    </small>
                                                )}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className='px-3'>
                        <div className='row mb-2 p-3'>
                            <div className='col-lg-12 mb-2'>
                                <div className="d-flex justify-content-between align-items-center mt-3">

                                    {/* Left side - checkbox + label */}
                                    <div className="form-check custom-checkbox d-flex align-items-center">
                                        <input
                                            type="checkbox"
                                            onChange={handleAddOnToggle}
                                            className="form-check-input me-3"
                                            id="customCheckBox1"
                                            checked={showAddOnSection}
                                        />
                                        <h4 className='font-w600 text-black m-0 fs-4' htmlFor="customCheckBox1">
                                            Add-On Services
                                        </h4>
                                    </div>

                                    {/* Right side - Add More button */}
                                    {showAddOnSection && (
                                        <button className="btn btn-sm btn-primary" onClick={handleAddConfig}>
                                            <i className="fa-solid fa-plus fs-6"></i>
                                            <span className='ms-2 fs-7'>Add More</span>
                                        </button>
                                    )}

                                </div>
                            </div>

                            {showAddOnSection && (
                                <>
                                    <div
                                        className="border rounded p-3 mb-3"
                                        style={{
                                            maxHeight: "350px",   // ⬅ change height if you want
                                            overflowY: rawMatrial.length > 3 ? "auto" : "visible",
                                            overflowX: "hidden"
                                        }}
                                    >
                                        {rawMatrial.map((config, index) => (
                                            <div key={config.id} data-repeater-item className="mb-1 pb-2 ">
                                                <div className='row p-1'>
                                                    <div className='col-lg-11'>
                                                        <div className='row'>

                                                            {/* Service */}
                                                            <div className='col-lg-3 mb-2'>
                                                                <label className="text-black font-w500 fs-7">
                                                                    Service<span className="required">*</span>
                                                                </label>
                                                                <Select
                                                                    placeholder='Select Service'
                                                                    value={config.selectedService}
                                                                    onChange={(option) => handleServiceChange(option, index)}
                                                                    options={addOnService}
                                                                    menuPortalTarget={document.body}
                                                                    styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                                                                />
                                                                {errors[`addOnService_${index}`] && (
                                                                    <small className="text-danger">{errors[`addOnService_${index}`]}</small>
                                                                )}
                                                            </div>

                                                            {/* Vendor (Conditional) */}
                                                            {config.selectedService?.vendor === 0 && (
                                                                <div className='col-lg-3 mb-2'>
                                                                    <label className="text-black font-w500 fs-7">
                                                                        Vendor<span className="required">*</span>
                                                                    </label>
                                                                    <Select
                                                                        placeholder='Select Vendor'
                                                                        value={config.selectedVendor}
                                                                        onChange={(option) => handleVendorChange(option, index)}
                                                                        options={vendors}
                                                                        menuPortalTarget={document.body}
                                                                        styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                                                                    />
                                                                    {errors[`addOnVendor_${index}`] && (
                                                                        <small className="text-danger">{errors[`addOnVendor_${index}`]}</small>
                                                                    )}
                                                                </div>
                                                            )}

                                                            {/* Quantity */}
                                                            <div className="col-lg-3 mb-2">
                                                                <label className="text-black font-w500 fs-7">
                                                                    No Of Units<span className="required">*</span>
                                                                </label>
                                                                <input
                                                                    type="number"
                                                                    className="form-control"
                                                                    placeholder="Enter Units"
                                                                    value={config.quantity}
                                                                    onChange={(e) => handleQuantityChange(e, index)}
                                                                />
                                                                {errors[`addOnQuantity_${index}`] && (
                                                                    <small className="text-danger">{errors[`addOnQuantity_${index}`]}</small>
                                                                )}
                                                            </div>

                                                            {/* Total Cost */}
                                                            <div className="col-lg-3 mb-2">
                                                                <label className="text-black font-w500 fs-7">Total Cost</label>
                                                                <input
                                                                    type="number"
                                                                    className="form-control"
                                                                    placeholder="Enter Total Cost"
                                                                    value={(config.totalCost || 0).toFixed(2)}
                                                                    readOnly
                                                                    disabled
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* Delete Button */}
                                                    <div className="col-lg-1 mb-1 px-1 py-1 d-flex align-items-center justify-content-end align-content-center">
                                                        {rawMatrial.length > 1 && (
                                                            <button
                                                                className="btn btn-danger px-2 py-2"
                                                                onClick={() => handleDeleteConfig(config.id)}
                                                                data-bs-toggle="tooltip"
                                                                data-bs-placement="top"
                                                                title="Delete"
                                                            >
                                                                <i className="fa-solid fa-trash-can fs-6 text-white"></i>
                                                            </button>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </>
                            )}
                        </div>
                    </div>

                    <div className='row mx-2 my-2'>
                        <div className='col-lg-6'>
                            <div
                                className="p-4 rounded"
                                style={{
                                    backgroundColor: '#f0f5ef',
                                    maxHeight: '330px',
                                    overflowY: 'auto',
                                }}
                                id="printableArea"
                            >
                                <h5 className="text-black font-w600 mb-3 fs-4"><i className="fa-solid fa-circle-check text-primary fs-5"></i> Selected Items</h5>

                                {/* GRID CONTAINER */}
                                <div
                                    className="d-flex flex-wrap gap-3"
                                    style={{ rowGap: "15px" }}
                                >
                                    {Object.entries(checkedItems).map(([itemId, isChecked]) => {
                                        if (!isChecked) return null;

                                        const item = categorizedItems
                                            .flatMap(group => group.items)
                                            .find(i => i.id.toString() === itemId.toString());

                                        if (!item) return null;

                                        const quantity = itemQuantities[itemId] || 0;

                                        return (
                                            <div
                                                key={itemId}
                                                className="p-3 rounded shadow-sm bg-white"
                                                style={{
                                                    width: "calc(50% - 10px)",   // 2 items per row
                                                    // To make 3 items per row, use: width: "calc(33.33% - 10px)"
                                                    border: "1px solid #e0e0e0",
                                                }}
                                            >
                                                <div className="fw-bold text-black fs-6">
                                                    {item.name}
                                                </div>

                                                <div className="d-flex justify-content-between align-items-center mt-1">
                                                     {/* <div className="fs-6 text-black">
                                                        {quantity} {getUnitSlugName(item.measurement_quantity)}
                                                    </div>   */}

                                                    <div className="fs-6 text-black">
                                                        {
                                                        (() => {
                                                            let displayQty = quantity;
                                                            let unitSlug = '';

                                                            // Conversion and unit based on measurement_quantity
                                                            if ([1, 2].includes(item.measurement_quantity)) {
                                                            // Kgs
                                                            displayQty = quantity / 1000;
                                                            unitSlug = 'kgs';
                                                            } else if ([3, 4].includes(item.measurement_quantity)) {
                                                            // Litres
                                                            displayQty = quantity / 1000;
                                                            unitSlug = 'ltrs';
                                                            } else if (item.measurement_quantity === 15) {
                                                            // No's
                                                            displayQty = quantity;
                                                            unitSlug = "no's";
                                                            } else {
                                                            // Default conversion
                                                            displayQty = quantity / 1000;
                                                            unitSlug = ''; // fallback, empty
                                                            }

                                                            // Format: remove trailing zeros after decimal
                                                            displayQty = parseFloat(displayQty.toFixed(3));

                                                            return `${displayQty} ${unitSlug}`;
                                                        })()
                                                        }
                                                    </div>
                                 
                                                    <div className="fw-bold text-primary fs-4">
                                                        ₹ {(parseFloat(item.cost || 0) * quantity).toFixed(2)}
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>

                                {/* Add-on Services Summary */}
                                {showAddOnSection && rawMatrial.length > 0 && (
                                    <>
                                        <h5 className="text-black font-w600 mb-3 fs-4 mt-2"><i className="fa-solid fa-circle-check text-primary fs-5"></i> Add-On Services</h5>

                                        <div
                                            className="d-flex flex-wrap gap-3"
                                            style={{ rowGap: "15px" }}
                                        >
                                            {rawMatrial.map((config, index) => (
                                                config.selectedService && (
                                                    <div
                                                        key={index}
                                                        className="p-3 rounded shadow-sm bg-white"
                                                        style={{
                                                            width: "calc(50% - 10px)",
                                                            border: "1px solid #e0e0e0",
                                                        }}
                                                    >
                                                        <div className="fw-bold text-black fs-6">
                                                            {config.selectedService.label}
                                                        </div>

                                                        <div className="d-flex justify-content-between align-items-center mt-1">
                                                            <div className="fs-6 text-black">
                                                                {config.quantity || 0} unit(s)
                                                            </div>

                                                            <div className="fw-bold text-primary fs-4">
                                                                ₹ {(parseFloat(config.selectedService.cost_per_unit || 0) *
                                                                    (config.quantity || 0)
                                                                ).toFixed(2)}
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            ))}
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>

                        <div className='col-lg-6'>
                            <div className='d-flex flex-column align-items-end justify-content-end py-4 px-4 rounded' style={{ backgroundColor: '#f0f5ef' }}>
                                <div className="col-lg-10 mb-2">
                                    <div className='d-flex flex-row gap-2 align-items-center justify-content-between'>
                                        <label className="text-black font-w500 fs-5">Total Cost<span className="required"></span></label>
                                        <span className='align-items-start text-black font-w500 fs-3'>{grandTotal.toFixed(2)}</span>
                                    </div>
                                </div>
                                <div className="col-lg-10 mb-2">
                                    <div className='d-flex flex-row gap-2 align-items-center justify-content-between'>
                                        <label className="text-black font-w500 fs-5">Confirm Cost<span className="required">*</span></label>
                                        <input type="text" className="form-control" placeholder="Enter Confirm Cost" style={{ width: '50%' }} value={confirmCost} onChange={handleConfirmCostChange} />
                                    </div>
                                    {errors.confirmCost && (
                                        <small className="text-danger">{errors.confirmCost}</small>
                                    )}
                                </div>
                                <OverlayTrigger
                                    trigger={['hover', 'focus']}
                                    placement="bottom"
                                    overlay={
                                        <Tooltip className='tooltip-popover'>
                                            <span className='fs-9 text-white fw-semibold'>
                                                Based On Refund Eligible
                                            </span>
                                        </Tooltip>
                                    }
                                >
                                    <div className="col-lg-10 mb-2">
                                        <div className='d-flex flex-row gap-2 align-items-center justify-content-between'>
                                            <label className="text-black font-w500 fs-5">
                                                Advance Amount<span className="required">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                inputMode="numeric"
                                                pattern="[0-9]*"
                                                className="form-control"
                                                placeholder="Enter Advance Amount"
                                                style={{ width: '50%' }}
                                                value={advanceAmountInput}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    setAdvanceAmountInput(value);

                                                    const parsed = parseFloat(value);
                                                    if (value === "" || isNaN(parsed)) {
                                                        setErrors(prev => ({
                                                            ...prev,
                                                            advanceAmount: "Advance Amount is required",
                                                        }));
                                                    } else if (parsed < advanceAmount) {
                                                        setErrors(prev => ({
                                                            ...prev,
                                                            advanceAmount: `Advance Amount must be ₹${advanceAmount} or more`,
                                                        }));
                                                    } else {
                                                        setErrors(prev => ({ ...prev, advanceAmount: null }));
                                                    }
                                                }}
                                            />
                                        </div>
                                        {errors.advanceAmount && (
                                            <small className="text-danger">{errors.advanceAmount}</small>
                                        )}
                                    </div>
                                </OverlayTrigger>
                                <div className="col-lg-10 mb-2">
                                    <div className='d-flex flex-row gap-2 align-items-center justify-content-between'>
                                        <label className="text-black font-w500 fs-5">
                                            Discount Coupon<span className="required"></span>
                                        </label>
                                        <div className="d-flex gap-2 w-50">
                                            <input type="text" className="form-control" placeholder="Enter Coupon" style={{ flex: 1, width: '5%' }} value={coupon} onChange={e => setCoupon(e.target.value)} />
                                            <button type="button" className="btn btn-sm btn-primary" style={{ whiteSpace: 'nowrap' }}><img src={arrow} alt='submit' onClick={handleApplyClick} /></button>
                                        </div>
                                    </div>
                                </div>
                                {couponAmount ? (
                                    <div className="col-lg-10 mb-2">
                                        <div className='d-flex flex-row gap-2 align-items-center justify-content-between'>
                                            <label className="text-black font-w500 fs-5">
                                                Coupon Amount
                                                <span className="required"></span>
                                            </label>
                                            <span className='align-items-start text-black font-w500 fs-3'>{couponAmount.toFixed(2)}</span>
                                        </div>
                                    </div>
                                ) : null}


                                <div className="col-lg-10 mb-2">
                                    <div className='d-flex flex-row gap-2 align-items-center justify-content-between'>
                                        <label className="text-black font-w500 fs-5">GST Amount ({gst_percentage}%)<span className="required"></span></label>
                                        <span className='align-items-start text-black font-w500 fs-3'>{gstAmount.toFixed(2)}</span>
                                    </div>
                                </div>
                                <div className="col-lg-10 mb-2">
                                    <div className='d-flex flex-row gap-2 align-items-center justify-content-between'>
                                        <label className="text-danger font-w500 fs-3">Grand Total<span className="required"></span></label>
                                        <span className='align-items-start text-red font-w500 fs-2'>{totalWithGst.toFixed(2)}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
                        <button
                            type="button"
                            className="btn btn-sm btn-primary"
                            onClick={handlePrint}
                        >
                            Preview Invoice
                            <i className="fas fa-file-alt ms-2"></i>
                        </button>
                        <button type="button" className="btn btn-sm btn-primary" onClick={handleSubmit}>
                            Create Order
                            <i className="fas fa-angle-double-right ms-2"></i>
                        </button>
                    </div>
                </>
            )}
        </>
    )


}
export default CateringOrder;